import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IUploader } from '../constants/shared/uploader-service-unique-ids';
import { UploaderService } from '../components/file-drop/uploader.service';

@Directive({
    selector: '[appUploaderProgress]',
})
export class UploaderProgressDirective implements OnInit, OnDestroy {
    @Input({ alias: 'uploadingService', required: true }) uploadingService!: IUploader;
    type: any;
    private readonly onDestroy$ = new Subject<void>();
    progress = 0;

    constructor(private uploaderServiceRef: UploaderService) {}

    ngOnInit(): void {
        const { type: localType } = this.uploadingService;
        this.type = localType;
        const uploadProgress$ = this.uploaderServiceRef.getUploadPercentageObservable(localType);

        if (uploadProgress$) {
            this.subscribeToProgress(uploadProgress$);
        } else {
            this.uploaderServiceRef.newUploader$.pipe(takeUntil(this.onDestroy$)).subscribe((uploader) => {
                if (uploader?.type === localType) {
                    this.subscribeToProgress(uploader.observable);
                }
            });
        }
    }

    private subscribeToProgress(progress$: Observable<number>): void {
        progress$.pipe(takeUntil(this.onDestroy$)).subscribe((progress) => {
            console.log(`NEW PROGRESS!!!`, this.type, progress);
            this.progress = progress;
        });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
